export default "__VITE_ASSET__4c2bd1f9__"